var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprehensiveCandidateProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 99.081,
    height: 84.341,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-506 -2230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(513 2245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M96.353,76.622H48.293V9.291h33.84V21.364A1.35,1.35,0,0,0,83.467,22.7H96.353ZM92,70.528H52.646a1.335,1.335,0,1,0,0,2.67H92a1.335,1.335,0,1,0,0-2.67m0-5.108H52.646a1.364,1.364,0,0,0,0,2.728H92a1.364,1.364,0,0,0,0-2.728m0-5.05H52.646a1.364,1.364,0,0,0,0,2.728H92a1.364,1.364,0,0,0,0-2.728m0-5.05H52.646a1.335,1.335,0,1,0,0,2.67H92a1.335,1.335,0,1,0,0-2.67m0-5.108H52.646a1.364,1.364,0,0,0,0,2.728H92a1.364,1.364,0,0,0,0-2.728m0-5.049H52.646a1.364,1.364,0,0,0,0,2.728H92a1.364,1.364,0,0,0,0-2.728M55.548,20.552a7.871,7.871,0,1,0,7.894-7.836,7.894,7.894,0,0,0-7.894,7.836M67.1,24.208a5.169,5.169,0,1,1,0-7.314,5.258,5.258,0,0,1,0,7.314M52.646,42.84H74.238a1.4,1.4,0,0,0,1.335-1.393V35.236A6.788,6.788,0,0,0,68.782,28.5h-1.1a1.429,1.429,0,0,0-.871.29,5.1,5.1,0,0,1-5.165.929,3.563,3.563,0,0,1-1.509-.871c-.581-.523-1.162-.348-2.09-.348a6.788,6.788,0,0,0-6.791,6.733v6.211a1.412,1.412,0,0,0,1.393,1.393m20.2-2.728H53.981V35.236A4,4,0,0,1,55.2,32.392a4.142,4.142,0,0,1,3.483-1.219,6.886,6.886,0,0,0,2.032,1.1l2.728.464a8,8,0,0,0,4.7-1.567h.639a4.075,4.075,0,0,1,4.063,4.063ZM94.321,19.971H84.861V11.09l8.822,8.3ZM46.957,79.292H64.312v2.321H2.728V64.49A14.764,14.764,0,0,1,17.471,49.747h2.9a19.325,19.325,0,0,0,5.92,3.367A20.593,20.593,0,0,0,45.565,50.56v27.4a1.363,1.363,0,0,0,1.393,1.335M83.467,6.621H48.7a20.776,20.776,0,1,0-3.135,31v9.519a1.028,1.028,0,0,0-.291.232,18.218,18.218,0,0,1-18.051,3.251,18.685,18.685,0,0,1-5.4-3.192,1.518,1.518,0,0,0-.987-.407H17.471A17.489,17.489,0,0,0,0,64.49V83.007a1.35,1.35,0,0,0,1.335,1.334H65.648a1.35,1.35,0,0,0,1.335-1.334V79.292H97.688a1.363,1.363,0,0,0,1.393-1.335V21.364l-.523-1.1-3.018-2.844L84.4,6.969Zm-37.786.812a1.685,1.685,0,0,0-.116.523V34.192a18.052,18.052,0,1,1,.116-26.758",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M23.243,34a18.091,18.091,0,0,0,24.843.639V8.4a1.7,1.7,0,0,1,.116-.522A18.068,18.068,0,0,0,23.243,34",
    transform: "translate(-2.521 -0.443)",
    fill: "#4f6cf6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M46.01,58.674a20.6,20.6,0,0,1-19.271,2.554,19.325,19.325,0,0,1-5.92-3.367h-2.9A14.764,14.764,0,0,0,3.173,72.605V89.728H64.757V87.406H47.4a1.363,1.363,0,0,1-1.393-1.334Z",
    transform: "translate(-0.445 -8.115)",
    fill: "#6e56ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M62.786,45.2H81.65V40.321a4.075,4.075,0,0,0-4.062-4.063h-.639a8.006,8.006,0,0,1-4.7,1.567l-2.728-.464a6.927,6.927,0,0,1-2.032-1.1,4.141,4.141,0,0,0-3.482,1.219,4,4,0,0,0-1.219,2.844Z",
    transform: "translate(-8.805 -5.085)",
    fill: "#6e56ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M83.451,36.752v6.21a1.4,1.4,0,0,1-1.335,1.394H60.524a1.413,1.413,0,0,1-1.394-1.394v-6.21a6.789,6.789,0,0,1,6.791-6.734c.929,0,1.51-.174,2.09.348a3.563,3.563,0,0,0,1.509.871,5.105,5.105,0,0,0,5.166-.929,1.422,1.422,0,0,1,.87-.291h1.1a6.788,6.788,0,0,1,6.791,6.734M60.524,46.677H99.878a1.364,1.364,0,0,1,0,2.728H60.524a1.364,1.364,0,0,1,0-2.728m0,5.05H99.878a1.364,1.364,0,0,1,0,2.728H60.524a1.364,1.364,0,0,1,0-2.728m0,5.108H99.878a1.335,1.335,0,1,1,0,2.67H60.524a1.335,1.335,0,1,1,0-2.67m0,5.049H99.878a1.364,1.364,0,0,1,0,2.728H60.524a1.364,1.364,0,0,1,0-2.728m0,5.05H99.878a1.364,1.364,0,0,1,0,2.728H60.524a1.364,1.364,0,0,1,0-2.728m0,5.108H99.878a1.335,1.335,0,1,1,0,2.67H60.524a1.335,1.335,0,1,1,0-2.67M56.17,78.137h48.06V24.214H91.345a1.35,1.35,0,0,1-1.335-1.335V10.806H56.17ZM71.32,14.23a7.871,7.871,0,1,1-7.894,7.836A7.871,7.871,0,0,1,71.32,14.23",
    transform: "translate(-7.877 -1.516)",
    fill: "#f3f3f3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M67.782,23.063A5.175,5.175,0,0,0,76.6,26.721a5.258,5.258,0,0,0,0-7.314,5.188,5.188,0,0,0-8.823,3.657",
    transform: "translate(-9.506 -2.513)",
    fill: "#4f6cf6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M98.7,12.9v8.88h9.461l-.638-.58Z",
    transform: "translate(-13.842 -1.809)",
    fill: "#f3f3f3",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 114,
    height: 114,
    transform: "translate(506 2230)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveCandidateProfiles);
export default __webpack_public_path__ + "static/media/comprehensiveCandidateProfiles.6bdc2f61c0b094f938338d0aadaddc26.svg";
export { ForwardRef as ReactComponent };